import { render } from "./HeroiconsOutlineRss.vue?vue&type=template&id=da806a46"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineRss.vue"]])

export default __exports__